<mat-toolbar>
    <mat-toolbar-row>
      <table style="width: 100%;">
        <tr>
          <td style="width: 20%; text-align: left;">
            <table routerLink="/principal" class="paddingDiv" style="cursor: pointer;">
              <tr>
                  <td style="text-align: center;background-color:transparent;">
                      <img src="../../../assets/imagenes/logoFav.png"
                      style="height: 5.5vh; background-color:transparent;">
                  </td>
              </tr>
            </table>  
          </td>
          <td style="width: 90%;"></td>
          <td style="width: 10%; text-align: right;">
            <label style="font-size: 15px;
                margin-right: 1vw;">{{nombreUsuario}}</label>
          </td>
          <td style="width: 10%;">
            <table>
              <tr>
                <td>
                  <i class="fas fa-user-circle fa-1x" style="width: 20px;;
                    font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                    margin-top: 0px; margin-right: 0.5em;"
                    [matMenuTriggerFor]="menu"
                  ></i>
                  <mat-menu #menu="matMenu" yPosition="above" class="remove-padding">
                    <div mat-menu-item>
                      <label routerLink="/micuenta">Mis datos</label>
                    </div>
                    <div mat-menu-item>
                      <label routerLink="/configuracion">Configuración</label>
                    </div>
                    <div mat-menu-item>
                      <label (click)="cerrarSesion()">Cerrar sesión</label>
                    </div>
                  </mat-menu>
                </td>
                <td>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <!-- <div style="width: 100%; text-align: right; vertical-align: top;">
        
      </div> -->
    </mat-toolbar-row>
    <!-- <mat-toolbar-row>
        <span style="font-size: 12px;">SimpleCRM helps you easily manage your contacts</span>
      </mat-toolbar-row> -->
  </mat-toolbar>
  <div style="height: 88vh;">
    <router-outlet></router-outlet>
  </div>
